import * as React from "react";

import AppModals from "@editor/components/AppModals";
import useCurrentProjectId from "@editor/hooks/useCurrentProjectId";

import { Outlet } from "react-router-dom";

import FullPageLoadingAnimation from "../components/FullPageLoadingAnimation";
import { ProjectWebsocketProvider } from "../components/ProjectWebsocketProvider";

export default function ChatLayout() {
  const projectId = useCurrentProjectId();

  if (!projectId) {
    return <FullPageLoadingAnimation />;
  }

  return (
    <ProjectWebsocketProvider projectId={projectId}>
      <div className="flex flex-col w-full h-full min-h-0">
        <AppModals />
        <Outlet />
      </div>
    </ProjectWebsocketProvider>
  );
}
